export const PAGE_W = 816;
export const PAGE_H = 1056;

export const BLOCKS = {
  company: { name: "Company name & address", labels: {} },
  invoice_hdr: { name: "Invoice # & phones", labels: { invoice: "Invoice #:", phone: "Phone #:", toll: "Toll Free#:" } },
  customer: { name: "Customer info", labels: { phone: "Phone Number:" } },
  service_info: { name: "Tech, date & contacts", labels: { tech: "Tech:", date: "Service Date:", admin: "Administrator:", contact: "Contact:", corp: "Corporate Info.:" } },
  months: { name: "Months & frequency", labels: { freq: "Frequency:" } },
  service_performed: { name: "Service performed", labels: { title: "Service Performed" }, lines: true },
  scales: { name: "Scales & sticker nos", labels: { title: "Scales", sticker: "Sticker Nos:" }, lines: true },
  other_equipment: { name: "Other equipment", labels: { title: "Other Equipment" }, lines: true },
  lifts: { name: "Lifts", labels: { title: "Lifts" }, lines: true },
  signatures: { name: "Signatures", labels: { tech: "Technician's Signature:", customer: "Customer's Signature:", date: "Date:" } },
  totals: { name: "Totals & terms", labels: { subtotal: "Subtotal:", tax: "Tax:", total: "Total:", parts: "Parts:", grand: "+Total:" } },
  text: { name: "Text box", labels: {}, custom: true },
  logo: { name: "Logo", labels: {}, custom: true },
  line: { name: "Line", labels: {}, custom: true },
};

const b = (key, x, y, w, size, extra = {}) => ({ key, x, y, w, size, bold: false, hidden: false, lines: 0, text: "", h: 60, labels: {}, ...extra });

export const DEFAULT_LAYOUT = {
  items: [
    b("company", 68, 28, 338, 30, { bold: true }),
    b("invoice_hdr", 422, 28, 338, 27, { bold: true }),
    b("line", 68, 157, 692, 1, { id: "hdr-line", h: 1 }),
    b("customer", 68, 162, 357, 15),
    b("service_info", 449, 162, 311, 15),
    b("months", 68, 274, 692, 15),
    b("service_performed", 68, 299, 692, 15, { lines: 6 }),
    b("scales", 68, 466, 692, 15, { lines: 6 }),
    b("other_equipment", 68, 646, 692, 15, { lines: 3 }),
    b("lifts", 68, 749, 692, 15, { lines: 6 }),
    b("signatures", 68, 914, 426, 15),
    b("totals", 510, 914, 250, 15),
  ],
};

export const newItem = (key) => b(key, 300, 40, key === "line" ? 300 : 220, 15, {
  id: `${key}-${Date.now().toString(36)}`, h: key === "logo" ? 80 : key === "line" ? 1 : 60, text: key === "text" ? "Your text" : "",
});

export const label = (it, k) => (it.labels?.[k] ?? BLOCKS[it.key]?.labels[k] ?? "");

export const SAMPLE_INVOICE = {
  number: "C26010101", service_date: "2026-01-01", tech: "RC", frequency: "3", months: [true, false, false, true, false, false, true, false, false, true, false, false],
  customer: { name: "Sample Customer", address: "123 Main St", city_state_zip: "Tyler, TX 75701", phone: "903-555-0100", administrator: "Jane Doe", contact: "John Doe", corporate_info: "Corporate" },
  service_performed: "Performed calibrations on the listed scales.", sticker_nos: "6301 a,b", scales: ["M# H350  S# 0920 Rice Lake scale"], other_equipment: [], lifts: ["M# Hoyer  S# 1234 patient lift"],
  subtotal: 100, parts: 0, tax_rate: 8.25, terms: "Net 30", items: [],
};
